import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
//#region comment metod

const CreateCookie = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CreateCookie,
        method: RequestType.POST,
        data,
    });
const UpdateCookie = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateCookie,
        method: RequestType.PUT,
        data,
    });
const DeleteCookie = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DeleteCookie,
        method: RequestType.POST,
        data,
    });
const CreateCookieType = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CreateCookieType,
        method: RequestType.POST,
        data,
    });
const UpdateCookieType = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateCookieType,
        method: RequestType.PUT,
        data,
    }); 

    const CookieManagementCommand = {
        CreateCookie,
        UpdateCookie,
        DeleteCookie,
        CreateCookieType,
        UpdateCookieType,
       };
      
      export default CookieManagementCommand;